<template>
    <gmap-map
        :center="center"
        :zoom="14"
        map-type-id="terrain"
        style="width: 400px; height: 500px"
        class="m-t-20"
    >
        <gmap-marker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :clickable="true"
                :draggable="true"
                @click="center=m.position"
        ></gmap-marker>
    </gmap-map>
</template>

<script>
import * as VueGoogleMaps from 'vue2-google-maps';
import Vue from 'vue';

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCllY8AgL62cVSWy6js7NkW8TskOTu2htM'
    }
});

export default {
    name: 'gmap',
    data () {
        return {
            center: {lat: 33.5099646, lng: -112.033876},
            markers: [{
                position: {lat: 33.5099646, lng: -112.033876}
            }],
        }
    },
    mounted() {
        // google.maps.event.addDomListener(window, 'load', initialize);
    }
}
</script>



// WEBPACK FOOTER //
// Gmap.vue?556f41ba